// module imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// file imports
import axiosInstance from '@/lib/axios';
import { IUser } from '@/types';

interface GetUserArgs {
  params?: Record<string, string | number>;
}

const getUsers = createAsyncThunk('user/getUsers', async ({ params = {} }: GetUserArgs, { rejectWithValue }) => {
  try {
    const query = new URLSearchParams(params as Record<string, string>).toString();
    const response = await axiosInstance.get(`/users${query ? `?${query}` : ''}`);
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response?.data?.error || 'Retrieving users failed');
  }
});

interface UserState {
  data: IUser[] | null;
  loading: boolean;
  error: string | null;
}

const userSlice = createSlice({
  name: 'user',
  initialState: {
    data: null,
    loading: false,
    error: null,
  } as UserState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // getUsers
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export { getUsers };
export default userSlice.reducer;
